import { Component, OnInit, ViewChild, AfterViewInit, Input, OnChanges, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SessionData, SessionDataService } from '../service/session-data.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SpinnerService } from '../../spinner-component/spinner.service';
import { MatDialog } from '@angular/material/dialog';
import { LogMoreInfoDialogComponent } from '../dailogs/log-more-info-dialog.component';
import { PageDetailsDialogComponent } from '../dailogs/page-details/page-details-dialog.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-session-table',
  templateUrl: './user-log.component.html',
  styleUrls: ['../user-behaviour.component.css']
,
  standalone: false
})
export class UserLogTableComponent implements OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('searchInput') searchInput: ElementRef;
  @Input() selectedTab: any;

  displayedColumns: string[] = ['username', 'source', 'userType', 'loginTimeInCT', 'logoutTimeInCT', 'timeSinceLogin', 'loginTimeInIST', 'logoutTimeInIST', 'city', 'region', 'addInfo'];
  dataSource = new MatTableDataSource<SessionData>();
  // pagedDataSource = new MatTableDataSource<SessionData>();

  sessions: SessionData[] = [];
  pageSize = 8;
  pageIndex = 0;
  totalElements = 0;
  isLoading = false;
  isInitialLoad = true;

  filteredData: SessionData[] = [];
  filterType: string = 'all';
  timeRange: string = 'day';
  source: string = '';
  startDate: Date | null = null;
  endDate: Date | null = null;
  searchKeyword: string = '';
  pvUser: string = '';
  userType: string = '';
  userState: string = '';
  pageType: string = '';
  authType: string = '';
  keepLogin: string = '';
  sessionLogin: string = '';
  country: string = '';
  fromDate: string ='';
  toDate: string = '';
  unique: boolean = false;

  constructor(private sessionDataService: SessionDataService, public spinner: SpinnerService, public dialog: MatDialog, private route: ActivatedRoute, private cdr: ChangeDetectorRef) {}

  shouldApplyFilterFromLocalStorage: boolean = false;

ngOnInit(): void {
  const storedTab = localStorage.getItem('selectedTab');
  this.selectedTab = storedTab ?? '0';
  this.timeRange = 'day';
    // Only load if this is the initial load and selectedTab is 1 (User Session Details tab)
    // Otherwise, let ngOnChanges handle it to avoid double calls
    if (this.selectedTab == '1' || this.selectedTab == 1) {
      this.loadFiltersFromLocalStorage();
      this.applyFilter();
      this.isInitialLoad = false;
    }
    // this.sessionDataService.getUserMetrics({pageIndex: this.pageIndex, pageSize: this.pageSize}).subscribe((sessions: any) => {
    //     debugger;
    //   this.sessions = sessions?.userAudit?.content;
    //   this.dataSource.data = sessions?.userAudit?.content;
    //   this.totalElements = sessions?.userAudit?.totalElements;
    //   this.applyFilter();
    //   this.spinner.deactivate();
    // });
  }

  ngOnChanges(changes: any): void {
    // Only call applyFilter if selectedTab changes to '1'
    if (changes.selectedTab && (changes.selectedTab.currentValue == '1' || changes.selectedTab.currentValue == 1)) {
      const previousValue = changes.selectedTab.previousValue;
      const currentValue = changes.selectedTab.currentValue;
      
      // If this is initial load (no previous value or previous value is same as current), 
      // ngOnInit will handle it, so skip here
      if (this.isInitialLoad && (previousValue === undefined || previousValue === null || String(previousValue) === String(currentValue))) {
        this.isInitialLoad = false;
        this.loadFiltersFromLocalStorage();
        return;
      }
      
      // This is a tab switch (previousValue exists and is different from currentValue), so load the data
      this.isInitialLoad = false;
      this.loadFiltersFromLocalStorage();
      this.applyFilter();
    }
  }

  ngAfterViewInit() {
    //this.pagedDataSource.paginator = this.paginator;
    
    if (this.shouldApplyFilterFromLocalStorage) {
    setTimeout(() => {
      localStorage.removeItem('userSessionFilters');
      this.shouldApplyFilterFromLocalStorage = false;
    }, 0);
  }
  this.dataSource.sort = this.sort;
  }

loadFiltersFromLocalStorage() {
  const savedFilters = localStorage.getItem('userSessionFilters');
    
  if (savedFilters) {
    const filters = JSON.parse(savedFilters);
    
    this.source = filters.source || '';
    this.pvUser = filters.pv || '';
    this.keepLogin = filters.keepLogin || '';
    this.userState = filters.userState || '';
    this.userType = filters.userType || '';
    this.timeRange = filters.timeRange || 'day';
 
    this.shouldApplyFilterFromLocalStorage = true;
  }
  else{
    this.source = '';
    this.pvUser = '';   
    this.keepLogin = '';
    this.userState = '';
    this.userType ='';
    this.timeRange = 'day';
  }
}

  loadSessions(fromDate: string, toDate: string): void {
    // Prevent multiple simultaneous API calls
    if (this.isLoading) {
      return;
    }
    
    const payload = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        fromDate: fromDate,
        toDate: toDate,
        query: this.searchKeyword,//btoa(this.searchKeyword),
        source: this.source,
        userType: this.userType,
        userState: this.userState,
        pv: this.pvUser,
        pageType: this.pageType == 'Error' ? '' : this.pageType,
        authType: this.authType,
        kmeloggedin: this.keepLogin,
        unique: this.unique,
        subType: this.pageType == 'Error' ? 'Error' : '',
        country: this.country,
        timeRange:this.timeRange
      };
      // Show loading indicator
      this.isLoading = true;
      this.cdr.detectChanges();
      
      // Also try to activate the spinner service
      this.spinner.activate();
      
      this.sessionDataService.getUserMetrics(payload).subscribe({
        next: (paginatedSessions: any) => {
          this.dataSource.data = paginatedSessions?.content || [];
          this.totalElements = paginatedSessions?.totalElements || 0;
          this.isLoading = false;
          this.spinner.deactivate();
        },
        error: (error) => {
          console.error('Error loading sessions:', error);
          this.isLoading = false;
          this.spinner.deactivate();
        }
      });
  }
  onTimeRangeChange(): void {
    this.pageIndex = 0;
    this.applyFilter();
  }

  onCustomDateChange(): void {
    this.applyFilter();
  }

  applySearchFilter(): void {
    // Don't allow search if already loading
    if (this.isLoading) {
      return;
    }
    // Remove focus from search input
    if (this.searchInput && this.searchInput.nativeElement) {
      this.searchInput.nativeElement.blur();
    }
    console.log("Unique selected:", this.unique);
    this.pageIndex = 0;
    this.applyFilter();
  }

  clearSearch(): void {
    // Don't allow clear if already loading
    if (this.isLoading) {
      return;
    }
    // Remove focus from search input
    if (this.searchInput && this.searchInput.nativeElement) {
      this.searchInput.nativeElement.blur();
    }
    this.searchKeyword = '';
    this.pageIndex = 0;
    this.applyFilter();
  }

  formatCurrentDateTime() {
    const now = new Date();
  
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
  
    const month = monthNames[now.getMonth()];
    const day = now.getDate();
    let hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;
  
    const formattedDateTime = `${month}_${day}_${hours}_${minutesStr}${ampm}`;
    return formattedDateTime;
  }

  downloadCSV(): void {
    const { fromDate, toDate } = this.returnFromToDate();
    this.spinner.activate();
    const payload = {
      fromDate: fromDate,
      toDate: toDate,
      query: this.searchKeyword,//btoa(this.searchKeyword),
      source: this.source,
      userType: this.userType,
      userState: this.userState,
      pv: this.pvUser,
      pageType: this.pageType == 'Error' ? '' : this.pageType,
      authType: this.authType,
      kmeloggedin: this.keepLogin,
      unique: this.unique,
      subType: this.pageType == 'Error' ? 'Error' : '',
      country: this.country
    };
    this.sessionDataService.getUserDataCSV(payload).subscribe(blob => {
      console.groupCollapsed('downloaded csv..');
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = `user_session_${this.formatCurrentDateTime()}.csv`;
      a.click();
      URL.revokeObjectURL(objectUrl);
      this.spinner.deactivate();
    })
  }

  returnFromToDate() {
    let fromDate: string;
    let toDate: string;
    const currentDate = new Date();
  
    if (this.timeRange === 'day') {
      fromDate = this.formatDateToLocal(currentDate, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
    } else if (this.timeRange === 'week') {
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
      fromDate = this.formatDateToLocal(startOfWeek, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
    } else if (this.timeRange === 'month') {
      const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      fromDate = this.formatDateToLocal(startOfMonth, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
    } else if (this.timeRange === 'custom' && this.startDate && this.endDate) {
      fromDate = this.customFormatDate(this.startDate);
      toDate = this.customFormatDate(this.endDate);
    } else {
      fromDate = this.formatDate(currentDate);
      toDate = this.formatEndDate(currentDate);
    }
    return {
      fromDate,
      toDate
    }
  }

  applyFilter(): void {
    const { fromDate, toDate } = this.returnFromToDate();
    this.loadSessions(fromDate, toDate);
  }
// appliedFilterFromDashboard(): void {
//   this.sessionDataService.getUserMetrics
// }
  customFormatDate(momentDate: any): string {
    const formattedDate =  momentDate.format('YYYY-MM-DD HH:mm:ss');
    return formattedDate;
  }

  formatDate(date: Date): string {
    return date.toISOString().split('T')[0] + ' 00:00:00';
  }

  formatDateToLocal(date: Date, perfix: string): string {
    const localDate = new Date(date.getTime());
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
  
    const formattedDate = `${year}-${month}-${day} ${perfix}`;
  
    return formattedDate;
  }
  

  formatEndDate(date: Date): string {
    return date.toISOString().split('T')[0] + ' 23:59:59';
  }

  applyFilter1(): void {
    let filteredData = this.dataSource.data;
    const currentDate = new Date();
    const currentDateString = currentDate.toISOString().split('T')[0];

    if (this.timeRange === 'day') {
      filteredData = filteredData.filter(session => 
        new Date(session.loginTimeInIST).toISOString().split('T')[0] === currentDateString
      );
    } else if (this.timeRange === 'week') {
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
      filteredData = filteredData.filter(session => 
        new Date(session.loginTimeInIST) >= startOfWeek
      );
    } else if (this.timeRange === 'month') {
      const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      filteredData = filteredData.filter(session => 
        new Date(session.loginTimeInIST) >= startOfMonth
      );
    } else if (this.timeRange === 'custom' && this.startDate && this.endDate) {
      filteredData = filteredData.filter(session => 
        new Date(session.loginTimeInIST) >= this.startDate && new Date(session.loginTimeInIST) <= this.endDate
      );
    }

    filteredData = filteredData.filter(session => {
      const username = session.username.trim().toLowerCase();
      const searchKeyword = this.searchKeyword.trim().toLowerCase();
      const source = this.source.toLowerCase();

      const isKeywordMatch = username.includes(searchKeyword);
      const isSourceMatch = session.source.toLowerCase().includes(source);

      let isUsernameValid = true;

      if (this.pvUser === 'PV') {
        isUsernameValid = username.endsWith('@pro-vigil.com') || !username.includes('@');
      } else if (this.pvUser === 'NON-PV') {
        isUsernameValid = !username.endsWith('@pro-vigil.com') && username.includes('@');
      }

      return isKeywordMatch && isSourceMatch && isUsernameValid;
    });

    this.filteredData = filteredData;
    this.updatePagedDataSource();
  }

  getMoreInfo(element: any): string {
    return JSON.stringify(element);
  }

  openPageDialog(element: any): void {
    //sessionId
    this.dialog.open(PageDetailsDialogComponent, {
      width: '700px',
      data: element
    });
  }

  openDialog(element: any): void {
    this.dialog.open(LogMoreInfoDialogComponent, {
      width: '700px',
      data: element,
      panelClass: 'custom-dialog-container'
    });
  }

  updatePagedDataSource(): void {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    const endIndex = startIndex + this.paginator.pageSize;
    //this.pagedDataSource.data = this.filteredData.slice(startIndex, endIndex);
    //this.paginator.length = this.filteredData.length; 
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    //this.updatePagedDataSource();
    //this.spinner.activate();
    //this.loadSessions();
    this.applyFilter();
  }

}
